import {OnlineActivitiesCounter, OnlineActivityCountersList} from "@service/store/types/OnlineActivitiesCounter";
import {OnlineActivityParam} from "@service/store/types/OnlineActivityParam";

const convertActivity = (item: OnlineActivityParam | string) => {
    if (typeof item == 'string') {
        return {
            name: item,
            take: 0
        } as OnlineActivityParam;
    }

    return item;
}

export const addItems = (list: OnlineActivityCountersList, activities: (OnlineActivityParam | string)[]): OnlineActivityCountersList => {
    let newList: OnlineActivityCountersList = {...list};

    activities.forEach((activity: OnlineActivityParam | string) => {
        let activityInstance = convertActivity(activity);

        if (!newList[activityInstance.name]) {
            newList[activityInstance.name] = {
                counter: 0,
                takes: []
            };
        }

        newList[activityInstance.name].counter++;
        newList[activityInstance.name].takes.push(activityInstance.take || 0);
    });

    return newList;
}

export const removeItems = (list: OnlineActivityCountersList, activities: (OnlineActivityParam | string)[]): OnlineActivityCountersList => {
    let newList = {...list};

    activities.forEach((activity: OnlineActivityParam | string) => {
        let activityInstance = convertActivity(activity);

        if (newList[activityInstance.name]) {
            newList[activityInstance.name].counter--;

            const indexToRemove = newList[activityInstance.name].takes.indexOf(activityInstance.take || 0);
            indexToRemove >= 0 && newList[activityInstance.name].takes.splice(indexToRemove, 1);

            if (newList[activityInstance.name].counter <= 0) {
                delete newList[activityInstance.name];
            }
        }
    });

    return newList;
}

export const getTake = (counter: OnlineActivitiesCounter) => {
    let result = 0;
    for (let i = 0; i < counter.takes.length; i++) {
        if (counter.takes[i] <= -1) {
            result = -1;
            break;
        }
        if (result < counter.takes[i]) {
            result = counter.takes[i];
        }
    }

    return result;
}